export enum BreadcrumbTypeEnum {
    ATTRACTION = 'ATTRACTION',
    EXPOSE_LABEL = 'EXPOSE_LABEL',
    HOME = 'HOME',
    OFFER = 'OFFER',
    PROPERTY_TYPE = 'PROPERTY_TYPE',
    REGION = 'REGION',
    TOPIC = 'TOPIC',
}

export enum TrackingEventTypeEnum {
    EVENT_EXPOSE_VIEW = 1,
    EVENT_EXPOSE_PRINT = 3,
    EVENT_INQUIRY_SENT = 2,
    EVENT_EXPOSE_PHONE_CLICK = 4,
    EVENT_BOOKING_SCHEDULE_CLICK = 7,
    EVENT_HOMEPAGE_REFERRER = 8,
    EVENT_LISTING_OVERVIEW = 9,
    EVENT_RESULT_VIEW = 10,
    EVENT_BOOKING_SENT = 11,
    EVENT_WIDGET_RATING = 12,
    EVENT_TOP_PROMOTION_VIEW = 13,
    EVENT_TOP_PROMOTION_CLICK = 14,
    EVENT_OFFER_VIEW = 15,
    EVENT_OFFER_CLICK = 16,
    EVENT_INQUIRY_FORM_VIEW = 17,
    EVENT_RATING_CHANGE_CLICK = 18,
    EVENT_RESULT_VIEW_PREMIUM_TOP_OBJECT = 19,
    EVENT_RESULT_CLICK_PREMIUM_TOP_OBJECT = 20,
    EVENT_RESULT_OBJECT_VIEW = 21,
    EVENT_RESULT_OBJECT_CLICK = 22,
    EVENT_INTERNAL_EXPOSE_VIEW = 1001,
}
